module.exports = __webpack_public_path__ + "ath_game_web/img/5.5.143a1178.png";